import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

const ContrastButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(theme.palette.primary.main),
    },
}))(Button);

export default ContrastButton